import React from "react";
import { IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ArrowIconBtn = ({ onClick, fontSize }) => {
  return (
    <div>
      <IconButton
        sx={{ background: "#C9DFF9", "&:hover": { background: "#C9DFF9" } }}
        onClick={onClick}
      >
        <ArrowForwardIosIcon fontSize={fontSize} />
      </IconButton>
    </div>
  );
};

export default ArrowIconBtn;
